import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  td {
    color: #696969;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  tr :last-child {
    font-weight: 400;
  }
`;
export const TransactionContainer = styled.div`
    width: 24em;
    margin-top: -1em; 
    
    
    @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 2em; 
    justify-content: center;
    width: 100%;
  }
`;
export const CardContainer = styled.div`
  width: 100%;
  align-items: center;
  margin-top: 1.69em;
  max-height: 25em;

  overflow: auto;
  & {
    scrollbar-width: normal;
  }
  &::-webkit-scrollbar {
    width: 0.4em;
  }
  &::-webkit-scrollbar-thumb {
    background: #cecece;
    border-radius: 1em;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #000;
  }
  &::-webkit-scrollbar-track {
    background: #fff;
  }
  @media (max-width: ${({ theme }) => theme.mobile.sm}) {
    &::-webkit-scrollbar {
      width: 0em;
    }
  }

  div {
    h3 {
    }
  }

  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
  }
`;
export const Empty = styled.div`
  width: 100%;
  margin: 1em auto;
  margin-left: 2em;
  p {
    margin-top: 3.1em;
    text-align: center;
    color: #ccc;
    font-family: Poppins;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    margin-left: 5em;
    padding-right: 0%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 5em;
    margin-left: 0em;
  }
`;
export const ImageContainer = styled.div`
  width: 5.625rem;
  height: 5.625rem;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
  }
`;
export const CardHeading = styled.h3`
  color: #DBDBDB;
font-family: Poppins;
font-size: 1rem;
font-style: normal;
font-weight: 400;
line-height: normal;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 1.31em;
    padding-top: 1.31em;
    border-top: 1px solid #d9d9d9;
  }
`;
